<template>
  <div class="container">
    <login />
    <router-link to="/forgot-password" >Mot de passe oublié</router-link>
  </div>
</template>

<script>
import Login from 'macarons/src/components/Login'

export default {
  components: {
    Login
  }
}
</script>
<style scoped>
.container {
  margin-left: auto;
  margin-right: auto;
  margin-top: 20vh;
  width: 95vW;
  max-width: 300px;
}
</style>
<style>
.container .login-form .el-button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/security/components/Login.vue